import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=dec7123a&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec7123a')) {
      api.createRecord('dec7123a', component.options)
    } else {
      api.reload('dec7123a', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=dec7123a&", function () {
      api.rerender('dec7123a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/complaintQuery/transfer.vue"
export default component.exports